import { ActionIcon, createStyles } from "@mantine/core";
import { useClipboard } from "@mantine/hooks";
import { tokens } from "@blurb/codex-react";
import { IconV3 } from "@rpi/openapi-core";
import React from "react";
import { Body } from "./Typography";

const useStyles = createStyles(() => ({
  row: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacing[1],
  },
  subtleText: {
    color: tokens.color.semantic.text.subtle,
  },
  monoId: {
    fontFamily: tokens.font.family.mono,
    // Long ids wrap across lines instead of forcing horizontal scroll.
    wordBreak: "break-all" as const,
  },
}));

/** A subtitle identifier line: "<label>: <mono value>" with a copy control. */
export const IdLine: React.FC<{ label: string; value: string; testId: string; copyTestId: string }> = ({
  label,
  value,
  testId,
  copyTestId,
}) => {
  const { classes } = useStyles();
  const clipboard = useClipboard({ timeout: 1500 });
  return (
    <div className={classes.row}>
      <Body size="sm" className={classes.subtleText} data-testid={testId}>
        <Body as="span" size="sm" weight="semibold">
          {label}:
        </Body>{" "}
        <Body as="span" size="sm" className={classes.monoId}>
          {value}
        </Body>
      </Body>
      <ActionIcon size="xs" variant="transparent" data-testid={copyTestId} onClick={() => clipboard.copy(value)}>
        <IconV3 icon="content_copy" size={16} />
      </ActionIcon>
    </div>
  );
};
